var MDB = window.MDB || {};
MDB.EmailCampaign = MDB.EmailCampaign || {};

(function() {

    var _EmailCampaignState = {
        campaignNew: 0,
        campaignActive: 1,
        campaignPaused: 2,
        campaignInactive: 3
    };

    var _EmailCampaignType = {
        campaignOnce: 0,
        campaignContinuously: 1,
        campaignManual: 2
    };

    var _ButtonTemplateBuilder = {
        Refresh: function(field, type) {
        //Only render field when it is not null/undefined
            var fieldValueTemplate = '#if(' + field + ' !== null && ' + field + ' !== undefined) {# #= ' + field + ' # # } #';
        
            return '<div class="count-container">' +
                '<label class="count-lbl" style="font-weight: normal">' + fieldValueTemplate + '</label>' +
                '<span class="pull-right align-bottom count-refresh-btn" style="font-weight:bold;font-size:large;" data-type="' + type + '"><i class="fa fa-refresh mdb-icon-btn"></i></span>' +
            '</div>';
        }
    };

    var _ButtonTemplate = {
        Activate:
        '<button class="pull-left w-50 btn btn-success btn-activate btn-sm" onclick="MDB.EmailCampaign.activateClick($(this))">' +
            '<span Class="pull-left align-bottom"><i class="fa fa-play"></i> ' + MDB.loadResourceString('Dpn_EmailCampaign_Index_Button_Activate_DisplayText') + '</span>' +
        '</button>',
        ActivateSend:
        '<button class="pull-left w-50 btn btn-success btn-activate btn-sm" onclick="MDB.EmailCampaign.activateClick($(this))">' +
            '<span Class="pull-left align-bottom"><i class="fa fa-play"></i> ' + MDB.loadResourceString('Dpn_EmailCampaign_Index_Button_ActivateSend_DisplayText') + '</span>' +
        '</button>',
        Reuse:
        '<button class="pull-left w-50 btn btn-warning btn-reuse btn-sm" onclick="MDB.EmailCampaign.reuseClick($(this))">' +
            '<span Class="pull-left align-bottom"><i class="fa fa-repeat"></i>' + MDB.loadResourceString('Dpn_EmailCampaign_Index_Button_Reuse_DisplayText') + '</span>' +
        '</button>',
        Pause:
        '<button class="pull-left w-50 btn btn-brand btn-twitter btn-pause btn-sm" onclick="MDB.EmailCampaign.pauseClick($(this))">' +
            '<span Class="pull-left"><i class="fa fa-pause"></i> ' + MDB.loadResourceString('Dpn_EmailCampaign_Index_Button_Pause_DisplayText') + '</span>' +
        '</button>',
        Delete:
        '<a class="btn-delete mdb-icon-btn delete" onclick="MDB.EmailCampaign.deleteClick($(this))">' +
            '&nbsp;<span style="font-weight:bold;font-size:large;"><i class="fa fa-trash-o"></i></span>' +
        '</a>',
        Edit:
        '<a class="btn-edit mdb-icon-btn edit" onclick="MDB.EmailCampaign.editClick($(this), true)">' +
            '<span style="font-weight:bold;font-size:large;"><i class="fa fa-pencil"></i></span>&nbsp;' +
        '</a>',
        Archive:
        '<a class="btn-archive mdb-icon-btn" onclick="MDB.EmailCampaign.archiveClick($(this))"> ' +
            '<span style="font-weight:bold;font-size:large;"><i class="fa fa-archive"></i></span>' +
        '</a>',
        History:
        '<a class="btn-history" onclick="MDB.EmailCampaign.historyClick($(this))"> ' +
            '<span class="pull-right align-bottom" style="font-weight:bold;font-size:large;"><i class="fa fa-history mdb-icon-btn"></i></span>' +
        '</a>',
        View: 
        '<a class="btn-view" onclick="MDB.EmailCampaign.viewClick($(this), false)"> ' +
            '<span class="align-bottom" style="font-weight:bold;font-size:large;"><i class="fa fa-eye mdb-icon-btn"></i></span>' +
        '</a>',
        SendTestRecord: 
        '<a class="btn-test-record" onclick="MDB.EmailCampaign.sendTestRecordClick($(this))"> ' +
            '<span class="align-bottom" style="font-weight:bold;font-size:large;"><i class="fas fa-vial mdb-icon-btn"></i></span>' +
        '</a>',
        Refresh: _ButtonTemplateBuilder.Refresh('LatestCount', 'count'),
        RefreshReminder: _ButtonTemplateBuilder.Refresh('LatestCountReminder', 'countReminder')
    };

    $.extend(MDB.EmailCampaign,
        {
            initGrid: function (grid, state) {
            
                var def = $.Deferred();

                var crudServiceBaseUrl = '/api/DPN/EmailCampaign/';
                //var grid = $('#new-campaigns-grid');

                var dataSource = new kendo.data.DataSource({
                    transport: {
                        read: function (opts) {
                            var url = crudServiceBaseUrl + 'Get' + '?state=' + state;
                            MDB.KendoConfigBuilder.dataSourceTransportFunction(url, 'GET', opts);
                        },
                        destroy: $.noop
                    },
                    batch: false,
                    pageSize: 20,
                    schema: {
                        model: {
                            id: 'Id',
                            fields: {
                                Id: { editable: false },
                                StartDate: { nullable: true, editable: false },
                                Name: { nullable: true, editable: false},
                                Offerings: { nullable: true, editable: false},
                                FreeFields: { nullable: true, editable: false},
                                Selection: { nullable: true, editable: false},
                                Description: { nullable: true, editable: false},
                                Type: { nullable: true, editable: false},
                                LatestCount: {nullable: true, editable: false},
                                LatestCountReminder: {nullable: true, editable: false},
                                Reminder: { nullable: true, editable: false}
                            }
                        }
                    },
                    error: function (e) {
                        this.cancelChanges();
                        alert(MDB.KendoConfigBuilder.getWebApiErrorsMessage(e));
                    }
                });

                var gridConfig = {
                    autoBind: true,
                    dataBound: function() {
                        var grid = this;

                        if(state == _EmailCampaignState.campaignNew) {
                            this.tbody.find('tr').each(function() {
                                var me = $(this);
                                var item = grid.dataItem(me);
                                var activateBtn = me.find('.btn-activate');

                                if(item.Type === _EmailCampaignType.campaignManual) {
                                    activateBtn.replaceWith(_ButtonTemplate.ActivateSend);
                                    activateBtn = me.find('.btn-activate');
                                } else {
                                    me.find('.btn-history').remove();
                                }

                                if(!item.SelectionEnabled ) {
                                    activateBtn.prop('disabled', true);
                                 
                                    //A selection needs to be enabled for counting to be possible
                                    me.find('.count-container').remove();
                                }
                            });
                        } else if (state == _EmailCampaignState.campaignActive) {
                            this.tbody.find('tr').each(function() {
                                var me = $(this);
                                var item = grid.dataItem(me);

                                if(item.State === _EmailCampaignState.campaignPaused){
                                 me.find('.btn-pause').replaceWith(_ButtonTemplate.Activate);
                                 me.find('.btn-view').remove();

                                } else {
                                    var edit = me.find('.btn-edit');
                                    var archive = me.find('.btn-archive');
                                    edit.addClass('disabled').attr('onclick', '');
                                    edit.tooltip('disable');
                                    archive.addClass('disabled').attr('onclick', '');
                                    archive.tooltip('disable');
                                }

                                if(item.Type === _EmailCampaignType.campaignManual) {
                                    me.find('.btn-activate').replaceWith(_ButtonTemplate.ActivateSend);
                                } else {
                                    me.find('.btn-history').remove();
                                }

                            });
                        } else if (state == _EmailCampaignType.campaignInactive) {
                            this.tbody.find('tr').each(function() {
                                var me = $(this);
                                var item = grid.dataItem(me);

                                if(item.Type != _EmailCampaignType.campaignManual) {
                                    me.find('.btn-history').remove();
                                }
                            });
                        }

                        MDB.EmailCampaign.initKendoTooltips(this);
                        def.resolve();
                    },
                    dataSource: dataSource,
                    pageable: MDB.KendoConfigBuilder.gridPageableSettings(),
                    columns: [
                        {
                            field: 'Id',
                            title: 'Id',
                            hidden: true
                        },
                        {
                            field: 'SelectionEnabled',
                            title: 'SelectionEnabled',
                            hidden: true
                        },
                        {
                            field: 'StartValue',
                            title: MDB.loadResourceString('Dpn_EmailCampaign_EmailCampaignModel_StartDate_DisplayName').replace(':',''),
                            hidden: false
                        },
                        {
                            field: 'Name',
                            title: MDB.loadResourceString('Dpn_EmailCampaign_EmailCampaignModel_Name_DisplayName').replace(':',''),
                            hidden: false
                        },
                        {
                            field: 'SelectionValue',
                            title: MDB.loadResourceString('Dpn_EmailCampaign_EmailCampaignModel_Selection_DisplayName').replace(':',''),
                            encoded: false
                        },
                        {
                            field: 'Description',
                            title: MDB.loadResourceString('Dpn_EmailCampaign_EmailCampaignModel_Description_DisplayName').replace(':',''),
                            encoded: false,
                            width: 300
                        },
                        {
                            field: 'TypeValue',
                            title: MDB.loadResourceString('Dpn_EmailCampaign_EmailCampaignModel_Type_DisplayName').replace(':',''),
                            encoded: false
                        },
                        {
                            field: 'LatestCount',
                            title: MDB.loadResourceString('Dpn_EmailCampaign_EmailCampaignModel_LatestCount_DisplayName').replace(':',''),
                            encoded: false,
                            template: _ButtonTemplate.Refresh
                        },
                        {
                            field: 'LatestCountReminder',
                            title: MDB.loadResourceString('Dpn_EmailCampaign_EmailCampaignModel_LatestCountReminder_DisplayName').replace(':',''),
                            encoded: false,
                            template: _ButtonTemplate.RefreshReminder
                        },
                        {
                            field: 'Reminder',
                            title: MDB.loadResourceString('Dpn_EmailCampaign_EmailCampaignModel_Reminder_DisplayName').replace(':',''),
                            encoded: false
                        }
                    ],
                    messages: {
                        commands: MDB.KendoConfigBuilder.commandLabels(),
                        noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
                    },
                    navigatable: true,
                    sortable: { mode: 'multiple' },
                    scrollable: false,
                    filterable: {
                        cell: {
                            enabled: false
                        }
                    }
                };
                gridConfig.editable = {
                    update: false,
                    destroy: false
                };

                if(state == _EmailCampaignState.campaignNew) {
                    gridConfig.columns.push(
                        MDB.KendoConfigBuilder.gridCommandColumn([
                            {
                                name: 'activate-campaign',
                                text: MDB.loadResourceString('Dpn_EmailCampaign_Index_Button_Activate_DisplayText'),
                                template: _ButtonTemplate.Activate + '&nbsp;'
                            },
                            {
                                name: 'history-campaign',
                                text: ' ',
                                template: _ButtonTemplate.History
                            }
                        ], 160, MDB.loadResourceString('Dpn_EmailCampaign_CampaignGrid_Activate_Title'))
                    );
                    gridConfig.columns.push(
                        MDB.KendoConfigBuilder.gridCommandColumn([
                            {
                                name: 'send-test-record',
                                text: ' ',
                                template: _ButtonTemplate.SendTestRecord + '&nbsp;' + '&nbsp;'
                            },
                            {
                                name: 'edit-campaign',
                                text: ' ',
                                template: _ButtonTemplate.Edit + '&nbsp;'
                            },
                            {
                                name: 'delete-campaign',
                                text: ' ',
                                template: _ButtonTemplate.Delete,
                            }
                        ], 91, MDB.loadResourceString('Dpn_EmailCampaign_CampaignGrid_Edit_Title'))
                    );
                } else if(state == _EmailCampaignState.campaignActive) {
                    gridConfig.columns.push(
                        MDB.KendoConfigBuilder.gridCommandColumn([
                            {
                                name: 'pause-campaign',
                                text: MDB.loadResourceString('Dpn_EmailCampaign_Index_Button_Pause_DisplayText'),
                                template: _ButtonTemplate.Pause + '&nbsp;'
                            },
                            {
                                name: 'history-campaign',
                                text: ' ',
                                template: _ButtonTemplate.History
                            }
                        ], 160, MDB.loadResourceString('Dpn_EmailCampaign_CampaignGrid_Inactive_Title')),
                        
                        MDB.KendoConfigBuilder.gridCommandColumn([
                            {
                                name: 'send-test-record',
                                text: ' ',
                                template: _ButtonTemplate.SendTestRecord + '&nbsp;' + '&nbsp;'
                            },
                            {
                                name: 'view-campaign',
                                text: ' ',
                                template: _ButtonTemplate.View + '&nbsp;' + '&nbsp;'
                            },
                            {
                                name: 'edit-campaign',
                                text: ' ',
                                template: _ButtonTemplate.Edit + '&nbsp;'
                            },
                            {
                                name: 'archive-campaign',
                                text: ' ',
                                template: _ButtonTemplate.Archive
                            }
                        ], 135, MDB.loadResourceString('Dpn_EmailCampaign_CampaignGrid_Edit_Title'))
                    );
                } else if(state == _EmailCampaignState.campaignInactive) {
                    gridConfig.columns.push(
                        MDB.KendoConfigBuilder.gridCommandColumn([
                            {
                                name: 'reuse-campaign',
                                text: MDB.loadResourceString('Dpn_EmailCampaign_Index_Button_Reuse_DisplayText'),
                                template: _ButtonTemplate.Reuse + '&nbsp;'
                            },
                            {
                                name: 'history-campaign',
                                text: ' ',
                                template: _ButtonTemplate.History
                            }
                        ], 160, MDB.loadResourceString('Dpn_EmailCampaign_CampaignGrid_Reuse_Title')),
                        MDB.KendoConfigBuilder.gridCommandColumn([
                            {
                                name: 'delete-campaign',
                                text: ' ',
                                template: _ButtonTemplate.Delete
                            }
                        ], 91)
                    );
                }
            
                grid.kendoGrid(gridConfig);
                return def.promise();
            }
        });
})();